import { render, staticRenderFns } from "./GastoList.vue?vue&type=template&id=37b4854e&scoped=true&"
import script from "./GastoList.vue?vue&type=script&lang=js&"
export * from "./GastoList.vue?vue&type=script&lang=js&"
import style0 from "./GastoList.vue?vue&type=style&index=0&id=37b4854e&lang=scss&scoped=true&"
import style1 from "./GastoList.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./GastoList.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b4854e",
  null
  
)

export default component.exports